import { parse } from "query-string";
import uuid from "react-uuid";
import HWLocalStorage from "../HWLibrary/HWLocalStorage";
class S360Config {
  sourceOrigin = null; // SDK client origin.
  clientHostId = null; // SDK client host Id.
  config = {};
  s360UserConfig = {};

  constructor() {
    if (!S360Config.instance) {
      S360Config.instance = this;
    }
    this.config = this.getConfig();
    return S360Config.instance;
  }

  // Configure client connection details.
  setSourceAndOriginFrom = (clientConfig) => {
    // console.log(clientConfig)
    this.sourceOrigin = clientConfig.sourceOrigin;
    this.clientHostId = clientConfig.clientHostId;
  };

  isClientHostConfigured = () => {
    return !(!this.sourceOrigin || !this.clientHostId);
    return (!this.sourceOrigin || !this.clientHostId);
  };

  getConfig = () => {
    if (!this.isClientHostConfigured()) {
      return {};
    }
    let chatConfigKey = this.clientHostId + "-s360-config-key";

    return HWLocalStorage.load(chatConfigKey) || {};
  };

  setConfig = (config) => {
    if (!this.isClientHostConfigured()) {
      return;
    }
    let chatConfigKey = this.clientHostId + "-s360-config-key";
    HWLocalStorage.save(config, chatConfigKey);
    this.loadS360Config();
  };

  loadS360Config = () => {
    if (!this.isClientHostConfigured()) {
      return;
    }
    let chatConfigKey = this.clientHostId + "-s360-config-key";
    let configData = HWLocalStorage.load(chatConfigKey) || {};
    this.config = configData; // Config variable below.
  };

  isConfigured = () => {
  
    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );
   
    let decodedString = this.decodeConfigToken(configEncodedString);

    if (this.config.viewType === "history") {
      return true;
    }
    if(decodedString!== undefined || decodedString!== null){
        if (
            decodedString?.action !== null ||
            decodedString?.hideLoading !== undefined ||
            decodedString?.subscriberId !== null
          ) {
            return true;
          } 
    }
      
    else if (
      window.location.href.includes("action")
    )
     {
      return true;
    }

    // if (!this.isClientHostConfigured()) { return false; }
    // let chatConfigKey = this.clientHostId + "-s360-config-key"

    // return !HWLocalStorage.load(chatConfigKey) != null;
  };

  loadClientConfigFromToken = () => {
    if (window.location.search) {
      var temp = parse(window.location.search);
      if (window.location.pathname === "/history") {
        temp.sourceOrigin = "-";
        temp.clientHostId = uuid();
        temp.viewType = "history";
        this.setSourceAndOriginFrom(temp);
        this.setUserConfig(temp);
        this.setConfig(temp);
      }
      // console.log("pathsearch", temp, window.location.pathname);
      return;
    } else {
      let decodedConfig = {};
      let configEncodedString = (window.location.pathname || "").substring(
        1,
        (window.location.pathname || "").length
      );
      // console.log(this.decodeConfigToken(configEncodedString),"here in here")
      if (configEncodedString) {
        if (window.location.href.includes("localhost:3030")) {
          // console.log("configEncodedString",configEncodedString)
          decodedConfig = this.decodeConfigToken(configEncodedString);
          // console.log(decodedConfig, "here");
        } else {
          decodedConfig = {
            sourceOrigin: `https://${window.location.hostname}`,
            clientHostId: "ececacc5-d941-48c6-9d79-ae47358d7117",
          };
        }
      } else {
        decodedConfig = this.decodeConfigToken(configEncodedString);
        decodedConfig = {
          sourceOrigin: `https://${window.location.hostname}`,
          clientHostId: "ececacc5-d941-48c6-9d79-ae47358d7117",
        };
      }

      if (!decodedConfig) {
        return null;
      }

      // if (decodedConfig.viewType === 'history') {
      //     decodedConfig.sourceOrigin = "-"
      //     decodedConfig.clientHostId = uuid();
      //     this.setSourceAndOriginFrom(decodedConfig);
      //     this.setUserConfig(decodedConfig);
      //     this.setConfig(decodedConfig);
      // }
      this.setSourceAndOriginFrom(decodedConfig);
      this.loadS360Config();
      this.loadS360UserConfig();
    }
  };

  decodeConfigToken = function (encodedStringURI) {
    if (!encodedStringURI) {
      return null;
    }
    let decodedStringURI = decodeURIComponent(encodedStringURI);
    let decodedBase64String = atob(decodedStringURI);
    let decodedSurveyConfiguration = JSON.parse(decodedBase64String);
    return decodedSurveyConfiguration;
  };

  // MARK: User From Configuration
  getUserConfig = () => {
    if (!this.isClientHostConfigured()) {
      return {};
    }
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    return HWLocalStorage.load(chatConfigKey) || {};
  };

  setUserConfig = (config) => {
    if (!this.isClientHostConfigured()) {
      return;
    }
    // console.log("config", config);
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    HWLocalStorage.save(config, chatConfigKey);
    this.loadS360UserConfig();
  };

  loadS360UserConfig = () => {
    if (!this.isClientHostConfigured()) {
      return;
    }
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    let config = HWLocalStorage.load(chatConfigKey) || {};
    this.s360UserConfig = config; // Config variable below.
  };

  isUserAttributesConfigured = () => {
    let chatConfigKey = this.clientHostId + "-s360-user-config-key";
    return HWLocalStorage.load(chatConfigKey) !== null;
  };
}

export var s360ConfigService = new S360Config();
// export var s360ConfigService = () => { return s360ConfigInstance; }
